import { render } from "./ApiTesterPage.vue?vue&type=template&id=ffd05bdc&scoped=true"
import script from "./ApiTesterPage.vue?vue&type=script&lang=js"
export * from "./ApiTesterPage.vue?vue&type=script&lang=js"

import "./ApiTesterPage.vue?vue&type=style&index=0&id=ffd05bdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd05bdc"]])

export default __exports__